import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 57,
	viewBox: "0 0 57 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M28.2199 43.5516C13.427 43.5516 1.44238 35.5251 1.44238 25.6123C1.44238 15.7113 13.427 7.68311 28.2199 7.68311C43.0128 7.68311 54.9975 15.7113 54.9975 25.6123C54.9975 35.5251 43.0128 43.5516 28.2199 43.5516ZM32.3169 14.6921C21.082 14.6921 11.9643 20.1832 11.9643 26.9562C11.9643 33.7293 21.082 39.2204 32.3169 39.2204C43.5517 39.2204 51.8595 35.4631 51.8595 26.9562C51.8595 18.4477 43.5601 14.6921 32.3169 14.6921ZM42.2179 35.4631C43.0999 35.7242 43.9534 36.0472 44.7902 36.4321C45.2705 36.6664 45.7057 36.9811 46.0889 37.356C46.3232 37.6087 46.524 37.8965 46.6797 38.2112L53.0712 48.9841H42.7417L37.9134 39.9182C37.4699 39.1266 36.936 38.3936 36.3185 37.7309C36.0038 37.3827 35.5603 37.1735 35.0884 37.1735H32.6382V48.9757L23.5054 48.9841V18.8242H41.853C41.853 18.8242 50.206 18.9732 50.206 26.9228C50.221 31.4298 46.7266 35.1769 42.2196 35.4648L42.2179 35.4631ZM38.2531 25.3613H32.7185V30.4875H38.2531C39.6924 30.5059 40.8589 29.3177 40.8171 27.8817C40.8957 26.4341 39.6924 25.2575 38.2531 25.363V25.3613Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgRDark);
export { ForwardRef as ReactComponent };
